import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import { NOTIFY_MESSAGE } from '../type';
import { initialState } from './initialize-state';

const companySiteReducer = handleActions(
  new Map([
    [
      NOTIFY_MESSAGE,
      (state, action) => {
        return update(state, {
          content: {
            $set: action.payload,
          },
        });
      },
    ],
  ]),
  initialState,
);
export default companySiteReducer;
